import React, { useEffect } from 'react';
import { generatePath, useParams } from 'react-router-dom';

import { ReactComponent as LoadingSpinner } from 'images/loader.svg';
import FormContainer from 'components/LoanForm/FormContainer';
import StateContainer from 'components/StateContainer';
import { useNavigate } from 'hooks/useNavigate';
import { RoutePath } from 'enums/Routes';

const UpdateAchWaitingAuthorization = () => {
  const navigate = useNavigate();
  const { loanId } = useParams<{ loanId: string }>();

  useEffect(() => {
    navigate(generatePath(RoutePath.PaymentSettings, { loanId }) as RoutePath);
  }, [navigate, loanId]);

  return (
    <div>
      <FormContainer>
        <StateContainer icon={<LoadingSpinner />} title="Waiting Authorization..." />
      </FormContainer>
    </div>
  );
};

export default UpdateAchWaitingAuthorization;
